export const action_types = {
  REQUEST_SPLASH: 'REQUEST_SPLASH',
  SUCCESS_SPLASH: 'SUCCESS_SPLASH',
  ERROR_SPLASH: 'ERROR_SPLASH',
  SUCCESS_SPLASH_IMAGES: 'SUCCESS_SPLASH_IMAGES',
}